import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

class DeadlineCounter extends Component {
    constructor() {
        super()
        this.state = {
            timerID: null,
            now: this.getNow(),
        }
    }

    componentDidMount() {
        this.setState({
            timerID: setInterval(() => this.refreshTimer(), 1000 * 30),
        })
    }

    componentWillUnmount() {
        clearInterval(this.state.timerID)
    }

    getNow() {
        return moment()
        // DEBUG: moment().hour(22) - past deadline, moment().hour(20) - one hour left
    }

    refreshTimer() {
        this.setState({
            now: this.getNow(),
        })
    }

    render() {
        const { t, deadline, deliveryDate } = this.props

        if (!moment(deliveryDate).isSame(moment().add(1, 'day'), 'day')) return null
        if (deadline === undefined) return null
        let remainingTime = moment(deadline).diff(this.state.now, 'minutes')
        let cartDeadlineCounterText = ''
        if (remainingTime >= 60) return null
        else if (remainingTime >= 1)
            cartDeadlineCounterText = t('cartDeadlineCounterSoon', { remainingTime })
        else if (remainingTime >= 0) {
            const deadlineTime = moment(deadline).format('HH:mm')
            cartDeadlineCounterText = t('cartDeadlineCounterLastMinute', {
                deadlineTime,
            })
        } else if (remainingTime < 0) cartDeadlineCounterText = t('cartDeadlineCounterPassed')

        return <div className="deadline">{cartDeadlineCounterText}</div>
    }
}

DeadlineCounter.propTypes = {
    t: PropTypes.func,
    deadline: PropTypes.object,
    deliveryDate: PropTypes.string,
}

export const mapStateToProps = ({ distribution, checkout }) => {
    return {
        deadline: distribution.deadline,
        deliveryDate: checkout.deliveryDate,
    }
}

export default connect(mapStateToProps)(withTranslation()(DeadlineCounter))
